import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface CompaniesApiConfigOptions extends ApiConfigOptions {}
export class CompaniesApiConfig extends Configuration {
  constructor(configOptions?: CompaniesApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
